import Vue from 'vue'

export default function logout({ from, next, router, to }) {
    if (Vue.cookie.get('access_token')) {
        Vue.cookie.delete('access_token')
    } 
    return next();
  }